import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NotificationTypeAction } from 'app/shared/models/notification.model';

@Component({
  selector: 'sc-notification-type-action',
  templateUrl: './notification-type-action.component.html'
})
export class NotificationTypeActionComponent implements OnInit {

  @Input() notificationId: number;
  @Input() notificationTypeActions: Array<NotificationTypeAction>;
  @Output() onActionTriggered: EventEmitter<any>;

  constructor() {
    this.onActionTriggered = new EventEmitter();
  }

  ngOnInit() {
  }

  actionTriggered() {
    this.onActionTriggered.emit();
  }

  getLinkId(displayText: string) {
    return `${displayText.toLowerCase().replace(/ /g, "-")}-link-notificaciones`;
  }
}
